// Libraries
import { FEATURES, NavGroup, type IShowroomBusinessEntityConfig } from '@makemydeal/dr-sales-checkin-types';
import type { ShowroomNavState, LogoConfig } from './types';

const getLogoConfigInitialState = (): LogoConfig => {
    return {
        logoURL: ''
    };
};

/**
 * Unified, config-driven nav entities across all four surfaces. Each entity is
 * only its identity, placement and declared visibility — static look lives in the
 * hook-layer registry, behaviour in commands. Adding/hiding/reordering a nav item
 * is a change here (plus a registry/command entry), not a component edit.
 */
const getEntitiesInitialState = (): IShowroomBusinessEntityConfig[] => [
    // Top nav
    { key: FEATURES.BUYER, groupBy: NavGroup.TopNav, isVisible: true },
    { key: FEATURES.BUYER_INBOX, groupBy: NavGroup.TopNav, isVisible: true },
    { key: FEATURES.ADD_COBUYER, groupBy: NavGroup.TopNav, isVisible: true },
    { key: FEATURES.COBUYER, groupBy: NavGroup.TopNav, isVisible: true },
    { key: FEATURES.COBUYER_INBOX, groupBy: NavGroup.TopNav, isVisible: true },
    { key: FEATURES.SEND_TO_DESK, groupBy: NavGroup.TopNav, isVisible: true },
    { key: FEATURES.DEAL_COMMENTS, groupBy: NavGroup.TopNav, isVisible: true },
    { key: FEATURES.SHARE_DROPDOWN, groupBy: NavGroup.TopNav, isVisible: true },
    // Share dropdown contents
    { key: FEATURES.CREDIT_APP, groupBy: NavGroup.Dropdown, isVisible: true },
    { key: FEATURES.DOC_UPLOAD, groupBy: NavGroup.Dropdown, isVisible: true },
    { key: FEATURES.DEAL_PDF, groupBy: NavGroup.Dropdown, isVisible: true },
    // Left nav (Build Your Offer)
    { key: FEATURES.VEHICLE_DETAILS, groupBy: NavGroup.LeftNav, isVisible: true },
    { key: FEATURES.TRADE_IN, groupBy: NavGroup.LeftNav, isVisible: true },
    { key: FEATURES.CUSTOMER_DETAILS, groupBy: NavGroup.LeftNav, isVisible: true },
    { key: FEATURES.DEAL_SUMMARY, groupBy: NavGroup.LeftNav, isVisible: true },
    // Quick links
    { key: FEATURES.BROWSE_INVENTORY, groupBy: NavGroup.QuickLink, isVisible: true },
    { key: FEATURES.MANAGE_DOCUMENTS, groupBy: NavGroup.QuickLink, isVisible: true },
    { key: FEATURES.RECENT_DEALS, groupBy: NavGroup.QuickLink, isVisible: true },
    { key: FEATURES.INSURANCE, groupBy: NavGroup.QuickLink, isVisible: true }
];

export const getShowroomNavInitialState = (): ShowroomNavState => {
    const config: ShowroomNavState = {
        entities: getEntitiesInitialState(),
        logoConfig: getLogoConfigInitialState(),
        isLeftNavOpen: false,
        isHamburgerVisible: true
    };

    return config;
};
